import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/modules/product-details/product-details.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/modules/productv2/productv2.tsx")